export type AppLocale = 'en' | 'ua'

/** Default UI language for the app. */
export const DEFAULT_LOCALE: AppLocale = 'ua'
